import React from 'react';
import { useForm, usePage } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../../components/ui/input-otp';
import { useTrans } from '../../hooks/useTrans';
import AuthCard from '../../components/layout/auth/AuthCard';

export default function AuthenticatorVerify() {
    const translate = useTrans();
    const { flash } = usePage().props;

    const { data, setData, post, processing } = useForm({
        verification_code: '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        post('/tweestapsverificatie/authenticator/configuratie/verifieren');
    }

    return (
        <AuthCard
            title={translate('Stap 2: Verifieer je authenticator-app')}
            backLink="/tweestapsverificatie/authenticator/configuratie/koppelen"
        >
            {flash && <Alert variant={flash.type}>{flash.description}</Alert>}

            <p>{translate('Voer de 6-cijferige code in die nu in je authenticator-app wordt weergegeven.')}</p>

            <form onSubmit={handleSubmit} autoComplete="off" className="mt-4">
                <div className="space-y-4">
                    <div className="flex justify-center">
                        <InputOTP
                            maxLength={6}
                            value={data.verification_code}
                            onChange={(value) => setData('verification_code', value)}
                        >
                            <InputOTPGroup>
                                <InputOTPSlot index={0} className="h-12 w-12 text-lg" />
                                <InputOTPSlot index={1} className="h-12 w-12 text-lg" />
                                <InputOTPSlot index={2} className="h-12 w-12 text-lg" />
                                <InputOTPSlot index={3} className="h-12 w-12 text-lg" />
                                <InputOTPSlot index={4} className="h-12 w-12 text-lg" />
                                <InputOTPSlot index={5} className="h-12 w-12 text-lg" />
                            </InputOTPGroup>
                        </InputOTP>
                    </div>

                    <Button variant="primary" type="submit" disabled={processing} className="w-full">
                        {translate('Verificatiecode controleren')}
                    </Button>
                </div>
            </form>
        </AuthCard>
    );
}
